import { useTypedQuery } from "hooks";
import { StatusListQueryKeys } from "modules/StatusListDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useStatusesListQuery = () =>
  useTypedQuery({
    queryKey: StatusListQueryKeys.statuses,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data.statuses
  });
